// removed by extract-text-webpack-plugin
module.exports = {"container":"ml_g","header":"ml_bg","info":"ml_cb","heading":"ml_i","price":"ml_mm ml_i","prevPrice":"ml_mn ml_mm ml_i","detail":"ml_mo","button":"ml_bp","arrow":"ml_g0"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventTicketsPage/components/TicketListItem/styles.module.css
// module id = 1337
// module chunks = 27